import GoInputAcl from "./go-input-acl.vue";
import GoCalendar from "./go-calendar.vue";
import GoCalendarRange from "./go-calendar-range.vue";
import GoCalendarMonth from "./go-calendar-month.vue";
import GoColorSel from "./go-color-sel.vue";
import GoColorThemeSel from './go-color-theme-sel.vue';
import GoSelUserByImg from "./go-sel-user-by-img.vue";

import GoRadio from "./go-radio.vue";
import GoRadioGroup from "./go-radio-group.vue";

import GoDrop from "./go-drop.vue";
import GoExplain from "./go-explain.vue";
import GoHidden from "./go-hidden.vue";
import GoInput from "./go-input.vue";
import goInputBtn from "./go-input-btn.vue";
import GoInputList from "./go-input-list.vue";
//密码输入框
import GoPwd from "./go-pwd.vue";
//多人本输入框
import GoTextarea from "./go-textarea.vue";

import GoDropGrid from "./go-drop-grid.vue";
import GoFileSelUpload from "./go-file-sel-upload";
import GoFileSingleInput from "./go-file-single-input";
import GoFormFile from "./go-form-file.vue";

import GoFormGroupLabel from "./go-form-group-label.vue";
import GoFormBody from "./go-form-body.vue";
import GoFormToolBar from "./go-form-tool-bar.vue";
import GoFormCtl from "./go-from-ctl.vue";

import GoMultipleDrop from "./go-multiple-drop.vue";

import GoNumberInput from "./go-number-input.vue";
import GoDropTree from "./go-drop-tree.vue";
import GoPwdStrength from "./go-pwd-strength.vue";

import GoRadioInput from "./go-radio-input.vue";
import GoCheckboxGroup from "./go-checkbox-input/go-checkbox-group.vue";
import GoCheckboxInput from "./go-checkbox-input/index";
import GoSwitch from "./go-switch.vue";
import GoWinDrop from "./go-win-drop.vue";

import GoEmpty from "./go-empty";//空输入组件
import GoInputImg from "./go-input-img";//图片输入组件
import GoVCode from "./go-v-code";//验证码组件

export default {
    GoCalendar,
    GoEmpty,
    GoInputImg,
    GoCalendarRange,
    GoCalendarMonth,
    goInputBtn,
    GoInputAcl,
    GoColorThemeSel,
    GoColorSel,
    GoDrop,
    GoExplain,
    GoHidden,
    GoInput,
    GoInputList,
    GoPwd,
    GoTextarea,
    GoDropGrid,
    GoPwdStrength,
    GoRadioInput,
    GoSwitch,
    GoFileSelUpload,GoFileSingleInput,
    GoFormGroupLabel,
    GoSelUserByImg,
    GoFormBody,
    GoFormCtl,
    GoMultipleDrop,
    GoNumberInput,
    GoDropTree,
    GoCheckboxInput,
    GoFormToolBar,
    GoFormFile,
    GoWinDrop,
    GoRadio,
    GoRadioGroup,
    GoCheckboxGroup,
    GoVCode,
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/index.js